<template>
  <div class="setting-wrap w-940 longheight">
    <div class="wrap-title">請求先情報</div>
    <el-form :model="userdata" :rules="rules_payment" ref="payment" style="width:100%" @submit.native.prevent="changePaymentInfo()">
      <div class="setting-subwrap top">
        <div class="setting-subtitle">会社名</div>
        <el-form-item class="setting-form" prop="bill_client_name">
          <el-input size="small" v-model="userdata.bill_client_name"></el-input>
        </el-form-item>
      </div>
      <div class="setting-subwrap">
        <div class="setting-subtitle">担当者名</div>
        <el-form-item class="setting-form" prop="bill_person_name">
          <el-input size="small" v-model="userdata.bill_person_name"></el-input>
        </el-form-item>
      </div>
      <div class="setting-subwrap">
        <div class="setting-subtitle">担当部署</div>
        <el-form-item class="setting-form" prop="bill_department">
          <el-input size="small" v-model="userdata.bill_department"></el-input>
        </el-form-item>
      </div>
      <div class="setting-subwrap">
        <div class="setting-subtitle">電話番号</div>
        <el-form-item class="setting-form" prop="bill_tel">
          <el-input size="small" v-model="userdata.bill_tel"></el-input>
        </el-form-item>
      </div>
      <div class="setting-subwrap">
        <div class="setting-subtitle">請求先メールアドレス</div>
        <el-form-item class="setting-form" prop="bill_email">
          <el-input size="small" v-model="userdata.bill_email"></el-input>
        </el-form-item>
      </div>
      <div class="setting-subwrap">
        <div class="setting-subtitle setting-subtitle-caution">請求先メールアドレス(CC)</div>
        <el-form-item class="setting-form" prop="bill_email_cc">
          <el-input size="small" v-model="userdata.bill_email_cc"></el-input>
          <span class="setting-subwrap-caution">
            ※CCの設定に関わらず、請求書はスーパー管理者へ送信されます
          </span>
        </el-form-item>
      </div>
      <div class="setting-subwrap">
        <div class="setting-subtitle">代表取締役名</div>
        <el-form-item class="setting-form" prop="bill_representative">
          <el-input size="small" v-model="userdata.bill_representative"></el-input>
        </el-form-item>
      </div>
      <div class="setting-subwrap">
        <div class="setting-subtitle">会社郵便番号</div>
        <el-form-item class="setting-form" prop="bill_post_code">
          <el-input size="small" v-model="userdata.bill_post_code"></el-input>
        </el-form-item>
      </div>
      <div class="setting-subwrap">
        <div class="setting-subtitle">会社住所(番地まで)</div>
        <el-form-item class="setting-form" prop="bill_address_1">
          <el-input size="small" v-model="userdata.bill_address_1"></el-input>
        </el-form-item>
      </div>
      <div class="setting-subwrap">
        <div class="setting-subtitle">会社住所(建物・ビル名)</div>
        <el-form-item class="setting-form" prop="bill_address_2">
          <el-input size="small" v-model="userdata.bill_address_2"></el-input>
        </el-form-item>
      </div>

      <div class="setting-button-area">
        <div class="divider-nomargin"></div>
        <el-button type="primary" size="small" native-type="submit" :disabled="loading">
          <div class="flex-row">
            変更を保存
            <div class="loader--mini" v-show="loading"></div>
          </div>
        </el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
const root = process.env.VUE_APP_API;
const changePaymentInfoAPI = root + "/api/auth/change_paymentinfo";

export default {
  name: "paymentInfo",
  props: ["userdata"],
  data() {
    return {
      loading: false,
      rules_payment: {
        bill_client_name: [{ required: true, message: "企業名は必須です", trigger: "blur" }],
        bill_person_name: [{ required: true, message: "担当者名は必須です", trigger: "blur" }],
        bill_department: [{ required: true, message: "担当部署は必須です", trigger: "blur" }],
        bill_email: [
          {
            required: true,
            message: "メールアドレスは必須です",
            trigger: "blur",
          },
        ],
        bill_email_cc: [{ type: "email", message: "不正なメールアドレス形式です", trigger: "blur" }],
        bill_tel: [{ required: true, message: "電話番号は必須です", trigger: "blur" }],
        bill_representative: [{ required: true, message: "代表取締役名は必須です", trigger: "blur" }],
        bill_post_code: [{ required: true, message: "会社郵便番号は必須です", trigger: "blur" }],
        bill_address_1: [{ required: true, message: "会社住所は必須です", trigger: "blur" }],
        bill_address_2: [{ required: false }],
      },
    };
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    user_token() {
      return this.$store.state.user_token;
    },
  },
  mounted() {},
  methods: {
    changePaymentInfo() {
      this.loading = true;
      this.$refs["payment"].validate((valid) => {
        if (valid) {
          var params = new URLSearchParams();
          params.append("bill_client_name", this.userdata.bill_client_name);
          params.append("bill_person_name", this.userdata.bill_person_name);
          params.append("bill_department", this.userdata.bill_department);
          params.append("bill_tel", this.userdata.bill_tel);
          params.append("bill_email", this.userdata.bill_email);
          params.append("bill_email_cc", this.userdata.bill_email_cc);
          params.append("bill_representative", this.userdata.bill_representative);
          params.append("bill_post_code", this.userdata.bill_post_code);
          params.append("bill_address_1", this.userdata.bill_address_1);
          params.append("bill_address_2", this.userdata.bill_address_2);
          params.append("token", this.token);
          this.axios.post(changePaymentInfoAPI, params).then(() => {
            this.$store.dispatch("getUserData", { token: this.token, user_token: this.user_token });
            this.$message({
              type: "success",
              offset: 7,
              showClose: true,
              message: "請求先情報を変更しました",
            });
            this.loading = false;
          }); 
        } else {
          this.$message({
            type: "error",
            offset: 7,
            showClose: true,
            message: "全ての項目を入力してください",
          });
          this.loading = false;
        }
      });
    },
  },
  watch: {},
  filters: {},
};
</script>
